var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-auto flex"},[(_vm.messages.length)?_c('div',{staticClass:"message-list flex-auto py2 px3"},_vm._l((_vm.messages),function(message){return _c('MessageItem',{key:message.messageId,attrs:{"message":message,"chat":_vm.chat}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }